class u {
  static isValid(t, e) {
    return t[e] !== void 0 ? !0 : Object.entries(t).filter(([o, s]) => e === s).length > 0;
  }
  static getValue(t, e) {
    const r = t[e];
    return r || u.getObjectByValue(t, e)[1];
  }
  static parse(t, e) {
    return t[e];
  }
  static getObjectByValue(t, e) {
    return Object.entries(t).filter(
      ([a, o]) => e === o
    )[0];
  }
}
export {
  u as E
};
